import { render } from "./Vault.vue?vue&type=template&id=2e7af67e&scoped=true&ts=true"
import script from "./Vault.vue?vue&type=script&lang=ts"
export * from "./Vault.vue?vue&type=script&lang=ts"

import "./Vault.vue?vue&type=style&index=0&id=2e7af67e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7af67e"]])

export default __exports__